import { Box, CircularProgress, Switch } from '@mui/material';

/**
 * A status switch that cannot be clicked twice.
 *
 * The thumb moves on click rather than on the response, so the admin gets the
 * acknowledgement that was missing -- and the switch locks until the write
 * finishes, so the second click has nothing to fire.
 *
 * The spinner sits in a fixed-width box whether or not it is showing, so a row
 * does not shift sideways every time somebody toggles it.
 */
export default function StatusSwitch({ checked, pending, onChange, disabled = false, ...rest }) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      <Box sx={{ width: 16, height: 16, display: 'inline-flex', alignItems: 'center' }}>
        {pending ? <CircularProgress size={14} thickness={5} /> : null}
      </Box>
      <Switch
        checked={!!checked}
        onChange={onChange}
        disabled={disabled || pending}
        color="primary"
        size="small"
        {...rest}
      />
    </Box>
  );
}
